import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { MicroSiteLeadData } from '.';

interface IAddMicroSiteData {
	mutate: UseMutateFunction<MicroSiteLeadData, Error, MicroSiteLeadData, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useAddMicroSiteMutation = (): IAddMicroSiteData => {
	const postMicroSiteAddData = async (siteLeadFormData: MicroSiteLeadData): Promise<MicroSiteLeadData> => {
		return await APIService.postData<MicroSiteLeadData>(APICONFIG.ADD_MICRO_SITE, siteLeadFormData);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: postMicroSiteAddData,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
